var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { keyframes } from '@emotion/core';
import { createOverridableComponent } from '../util/OverridableComponent';
var shineAnimation = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n0% {\n  background-position-x: -400px;\n}\n\n80%, 100% {\n  background-position: 400px;\n}\n"], ["\n0% {\n  background-position-x: -400px;\n}\n\n80%, 100% {\n  background-position: 400px;\n}\n"])));
export var Skeleton = createOverridableComponent('div', function (_a, Component) {
    var _b = _a.baseColor, baseColor = _b === void 0 ? '#dfe3e8' : _b, _c = _a.shineColor, shineColor = _c === void 0 ? '#eff1f3' : _c, props = __rest(_a, ["baseColor", "shineColor"]);
    return (jsx(Component, __assign({}, props, { sx: {
            backgroundImage: "linear-gradient(120deg, ".concat(baseColor, " 140px, ").concat(shineColor, " 240px, ").concat(baseColor, " 340px)"),
            backgroundSize: 1000,
            animation: "1.6s linear infinite ".concat(shineAnimation),
        } })));
});
var templateObject_1;
//# sourceMappingURL=Skeleton.js.map